import { render, staticRenderFns } from "./dadosEmail.vue?vue&type=template&id=5e0b0633&"
import script from "./dadosEmail.vue?vue&type=script&lang=js&"
export * from "./dadosEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports